/* UNIK Slider — JS */

(function () {
  'use strict';

  class UnikSlider {
    constructor(el) {
      this.el = el;
      this.slides = [...el.querySelectorAll('.unik-slider__slide')];
      this.dots = [...el.querySelectorAll('.unik-slider__dot')];

      if (this.slides.length === 0) return;

      this._initObserver();
      this._initDots();
    }

    _initObserver() {
      const options = {
        root: this.el,
        threshold: 0.5
      };

      this._observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            const idx = this.slides.indexOf(entry.target);
            this._setActiveDot(idx);
            this._updateDotColors(idx);
          } else {
            entry.target.classList.remove('is-visible');
          }
        });
      }, options);

      this.slides.forEach((slide) => this._observer.observe(slide));
    }

    _initDots() {
      this.dots.forEach((dot, i) => {
        dot.addEventListener('click', () => {
          this.slides[i]?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      });
    }

    _setActiveDot(index) {
      this.dots.forEach((d, i) => {
        d.classList.toggle('is-active', i === index);
      });
    }

    _updateDotColors(index) {
      const slide = this.slides[index];
      if (!slide) return;
      const textColor = slide.style.color || '#000';
      this.dots.forEach((d) => {
        d.style.color = textColor;
      });
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.unik-slider').forEach((el) => {
      new UnikSlider(el);
    });
  });
})();
